import React from 'react'
import classNames from 'classnames'
import { observer } from 'mobx-react'

import SimpleDropdown from 'components/SimpleDropdown'

import './index.scss'

const InlineDropdown = observer(
  ({ label, type = '', options, selected, onChange, tooltipText = '', tooltipPlace = 'right', disabled = false }) => {
    const containerClass = classNames('inline-dropdown-container', { selector: type === 'select' })

    return (
      <div className={containerClass}>
        {label && (
          <div className="label-container">
            <span>{label}</span>
          </div>
        )}
        <SimpleDropdown
          options={options}
          onChange={onChange}
          selected={selected}
          tooltipText={tooltipText}
          tooltipPlace={tooltipPlace}
          disabled={disabled}
        />
      </div>
    )
  }
)

InlineDropdown.propTypes = {}

InlineDropdown.defaultProps = {}

InlineDropdown.displayName = 'InlineDropdown'

export default InlineDropdown
